import { render, staticRenderFns } from "./thirdpartyTagManage.vue?vue&type=template&id=0528175a&scoped=true&"
import script from "./thirdpartyTagManage.vue?vue&type=script&lang=js&"
export * from "./thirdpartyTagManage.vue?vue&type=script&lang=js&"
import style0 from "./thirdpartyTagManage.vue?vue&type=style&index=0&id=0528175a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528175a",
  null
  
)

export default component.exports